function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as orderListApi from '@/api/orderListApi.js';
import * as logistics from '@/api/logistics';
import { Debounce } from '@/utils/validate';
import * as toolUtils from '@/utils/toolUtils.js';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      details: {},
      // 预留一份数据
      orderNo: '',
      pram: {},
      initloading: false,
      addresData: []
    };
  },
  mounted: function mounted() {
    this.getCityList();
    this.pram = {};
  },
  methods: {
    openInit: function openInit(orderNo) {
      this.orderNo = orderNo;
      this.pram = {};
      this.getOrderDetails(orderNo);
    },
    handerSubmit: Debounce(function () {
      var _this = this;
      this.$refs['pramRef'].validate(function (valid) {
        if (!valid) return;
        var _this$pram = _this.pram,
          _this$pram$addressIds = _this$pram.addressIds,
          addressIds = _this$pram$addressIds === void 0 ? [] : _this$pram$addressIds,
          receiverPhone = _this$pram.receiverPhone,
          receiverName = _this$pram.receiverName,
          receiverDetailAddr = _this$pram.receiverDetailAddr;
        if (receiverPhone && !toolUtils.isPhoneNumber(receiverPhone)) {
          _this.$message.warning('请输入正确的手机号！');
          return;
        }
        ;
        _this.loading = true;
        var _ref = addressIds || [],
          _ref2 = _slicedToArray(_ref, 3),
          receiverProvince = _ref2[0],
          receiverCity = _ref2[1],
          receiverRegion = _ref2[2];
        orderListApi.updateReceive({
          orderNo: _this.orderNo,
          receiverProvince: receiverProvince,
          receiverCity: receiverCity,
          receiverRegion: receiverRegion,
          receiverPhone: receiverPhone,
          receiverName: receiverName,
          receiverDetailAddr: receiverDetailAddr
        }).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getOrderDetails: function getOrderDetails(orderNo) {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.pram = {};
      orderListApi.getOrderDetail(orderNo).then(function (res) {
        var _ref3 = res.orderDelivery || {},
          receiverProvince = _ref3.receiverProvince,
          receiverCity = _ref3.receiverCity,
          receiverRegion = _ref3.receiverRegion,
          receiverPhone = _ref3.receiverPhone,
          receiverName = _ref3.receiverName,
          receiverDetailAddr = _ref3.receiverDetailAddr;
        _this2.pram = {
          orderNo: _this2.orderNo,
          addressIds: [receiverProvince, receiverCity, receiverRegion],
          receiverPhone: receiverPhone,
          receiverName: receiverName,
          receiverDetailAddr: receiverDetailAddr
        };
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    },
    // 获取地区数据
    getCityList: function getCityList() {
      var _this3 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this3.addresData = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    }
  }
};